import { render, staticRenderFns } from "./Reloads.vue?vue&type=template&id=2fc9e780&scoped=true"
import script from "./Reloads.vue?vue&type=script&lang=js"
export * from "./Reloads.vue?vue&type=script&lang=js"
import style0 from "./Reloads.vue?vue&type=style&index=0&id=2fc9e780&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc9e780",
  null
  
)

export default component.exports